import { wrapPromise } from "./wrapPromise";
import memoize from "memoize-one";
import axios from "axios"
import { appConfig } from './config'
import { transformQueryString} from './utils'

// testing
const commentsApi = () => {
  return new Promise(resolve => {
    setTimeout(() => {
      console.log('do resolve')
      resolve({ success: 'success' });
    }, 1000);
  });
};


export const getUrl = ({ path, queryString, isApi }) => {
  if (!queryString) queryString = {}
  queryString.mode = process.env.NODE_ENV
  let textStr = ''
  if (isApi) {
    textStr = transformQueryString(queryString)
  }
  const endPoint = (isApi) ? appConfig.apiEndPoint : appConfig.domain
  return `${endPoint}/${path}${textStr}`
}

const handleError = (err, reject) => reject(err)

const createHeader = async (header = { "Content-Type": "application/json" }) => {
  const headers = header
  const instance = axios.create({
    headers
  })
  return instance
}

export const getAppResource = memoize((dispatch) => {
  return wrapPromise(
    new Promise(async (resolve) => {
      try {

        const res = await get({ path: 'auth' })
        dispatch({ type: 'INIT_APP', data: res.data })
        resolve()
        // setTimeout(async () => {
        //   const response = await axios.get('https://jsonplaceholder.typicode.com/users/1');

        //   dispatch({ type: 'INIT_APP', data: response.data})
        //   resolve()
        // }, 0);
      } catch (error) {
        dispatch({ type: 'INIT_APP', data: null })
        resolve()
      }

    })
  );
})


// METHODS

export const get = async ({ path, queryString }, isApi = true) => {
  const instance = await createHeader()
  return new Promise((resolve, reject) => {
    instance
      .get(getUrl({ path, queryString, isApi }))
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        handleError(err, reject)
      })
  })
}

export const post = async ({ path, data }, isApi = true) => {
  const instance = await createHeader()
  return new Promise((resolve, reject) => {
    instance
      .post(getUrl({ path, isApi }), data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        handleError(err, reject)
      })
  })
}

export const put = async ({ path, data }, isApi = true) => {
  const instance = await createHeader()
  return new Promise((resolve, reject) => {
    instance
      .put(getUrl({ path, isApi }), data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        handleError(err, reject)
      })
  })
}

export const deleteItem = async ({ path, queryString }, isApi = true) => {
  const instance = await createHeader()
  return new Promise((resolve, reject) => {
    instance
      .delete(getUrl({ path, queryString, isApi }))
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        handleError(err, reject)
      })
  })
}


export const uploadFiles = async ({ path, data }, isApi = true) => {
  const instance = await createHeader({'content-type': 'multipart/form-data'})
  return new Promise((resolve, reject) => {
    instance
      .post(getUrl({ path, isApi }), data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        handleError(err, reject)
      })
  })
}

export const postWithForm = async ({ path, data }, isApi = true) => {
  const instance = await createHeader({'content-type': 'multipart/form-data'})
  return new Promise((resolve, reject) => {
    instance
      .post(getUrl({ path, isApi }), data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        handleError(err, reject)
      })
  })
}
